<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="show"
        class="fixed inset-0 z-50 overflow-y-auto"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <!-- Overlay -->
        <div
          class="fixed inset-0 backdrop-blur-sm transition-opacity"
          @click="handleClose"
        />

        <!-- Modal Container -->
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <!-- Modal -->
          <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full relative z-10">
            <!-- Header -->
            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div class="flex items-start">
                <div class="mt-3 text-center sm:mt-0 sm:text-left w-full">
                  <h3 id="modal-title" class="text-lg leading-6 font-medium text-gray-900 mb-4">
                    Politique de confidentialité
                  </h3>
                  
                  <div class="mt-2 max-h-96 overflow-y-auto">
                    <div class="text-sm text-gray-500 space-y-4">
                      <p>
                        <strong>1. Collecte des données</strong><br>
                        Nous collectons uniquement les informations nécessaires au fonctionnement de la plateforme : nom, email, fonction et affiliation (optionnels).
                      </p>
                      
                      <p>
                        <strong>2. Utilisation des données</strong><br>
                        Vos données sont utilisées pour vous identifier, vous contacter et personnaliser votre expérience sur la plateforme.
                      </p>
                      
                      <p>
                        <strong>3. Partage des données</strong><br>
                        Nous ne vendons, n'échangeons ni ne louons vos informations personnelles à des tiers.
                      </p>
                      
                      <p>
                        <strong>4. Sécurité</strong><br>
                        Nous mettons en place des mesures de sécurité appropriées pour protéger vos données contre l'accès non autorisé.
                      </p>
                      
                      <p>
                        <strong>5. Cookies</strong><br>
                        Nous utilisons des cookies pour maintenir votre session et améliorer votre expérience utilisateur.
                      </p>
                      
                      <p>
                        <strong>6. Vos droits</strong><br>
                        Vous avez le droit d'accéder, de modifier ou de supprimer vos données personnelles à tout moment.
                      </p>
                      
                      <p>
                        <strong>7. Contact</strong><br>
                        Pour toute question concernant cette politique, contactez-nous via le formulaire d'aide.
                      </p>
                      
                      <p class="text-xs text-gray-400">
                        Dernière mise à jour : 26 mai 2025
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Footer -->
            <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <button
                type="button"
                class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm transition-colors"
                @click="handleClose"
              >
                J'ai compris
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue';

export interface PrivacyModalProps {
  modelValue: boolean;
}

export interface PrivacyModalEmits {
  (e: 'update:modelValue', value: boolean): void;
}

const props = defineProps<PrivacyModalProps>();
const emit = defineEmits<PrivacyModalEmits>();

const show = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value),
});

const handleClose = (): void => {
  show.value = false;
};
</script> 